import { get as _get, post as _post, patch as _patch, del as _del, put as _put } from 'superagent';
import { getToken } from './auth';

// Drop-in replacement for superagent's verb functions that attaches the current
// Firebase ID token as a Bearer header on every request. The admin API now requires
// this (see is-admin.middleware.ts) — requests without a valid, admin-role token get
// a 401/403 instead of the old "only works from the emulator on 127.0.0.1" gate.
const withAuth = (request) => {
    const token = getToken();
    return token ? request.set('Authorization', `Bearer ${token}`) : request;
};

export const get = (url) => withAuth(_get(url));
export const post = (url) => withAuth(_post(url));
export const patch = (url) => withAuth(_patch(url));
export const put = (url) => withAuth(_put(url));
export const del = (url) => withAuth(_del(url));
